import {
  Box,
  Button,
  IconButton,
  Popover,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { CloseSmall } from "assets/Icon";
import { DialogTitleWrapper } from "components/Modal";
import PortfolioChart from "pages/Portfolio/Components/PortfolioCard/Components/PortfolioChart";
import PortfolioDetail from "./PortfolioDetail";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useChangeTheme from "hooks/useChangeTheme";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function PortfolioPopover({ anchorEl, onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const changeTheme = useChangeTheme();

  const portfolioChart = useSelector(
    (state) => state.portfolio.portfolioChart?.data
  );

  const open = Boolean(anchorEl);
  const id = open ? "portfolio-popover" : undefined;

  return (
    <PopoverStyle
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <DialogTitleWrapper>
        <Typography variant="h6" color="common.white">
          Portfolio
        </Typography>

        <IconButton onClick={onClose} color="common.white">
          <CloseSmall color={theme.palette.common.white} />
        </IconButton>
      </DialogTitleWrapper>

      <ContentWrapper>
        <PortfolioChart
          portfolioChart={portfolioChart?.creditDetail}
          lightThemModal={changeTheme.theme === "secondary" ? true : false}
        />

        <PortfolioDetail />

        <Button
          fullWidth
          color={actionButtonBg(theme)}
          onClick={() => navigate("/portfolio")}
        >
          Show More
        </Button>
      </ContentWrapper>
    </PopoverStyle>
  );
}

const PopoverStyle = styled(Popover)(() => ({
  ".MuiPaper-root": {
    width: "450px",
    maxWidth: "100%",
    borderRadius: "8px",
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export default PortfolioPopover;
